<template>
  <div class="basic_wrap">
    
    <!-- 顶部导航标题 -->
    <div class="page_header">
      <div class="header_title">{{ $t('home.team') }}</div>
    </div>

    <!-- ================= 1. 顶部邀请人信息大卡片 ================= -->
    <div class="card_box user_card">
      <!-- 头像与名字 -->
      <div class="user_info_top">
        <div class="avatar_box">
          <img :src="user_info.user_icon" alt="avatar">
        </div>
        <div class="info_mid">
          <div class="user_row">
            <span class="user_name">{{ user_info.username }}</span>
            <span class="vip_tag">{{ user_info.vip_name }}</span>
          </div>
          <div class="user_row">
            <span class="sub_text">{{ $t('user.invite_code') }}: {{ user_info.invite_code }}</span>
            <div class="copy_btn" @click="copyText(user_info.invite_code)">
              <img class="copy_icon" src="../img/user/copy.png">
              <em>Copy</em>
            </div>
          </div>
        </div>
      </div>

      <!-- 邀请链接 -->
      <div class="invite_link_row">
        <span class="sub_text link_text">{{ $t('team.inviteLink') }}{{ user_info.share_link }}</span>
        <div class="copy_btn" @click="copyText(user_info.share_link)">
          <img class="copy_icon" src="../img/user/copy.png">
          <em>Copy</em>
        </div>
      </div>

      <!-- 总收益与今日/昨日 -->
      <div class="revenue_section">
        <div class="row_label">{{ $t('team.totalRevenue') }}</div>
        <div class="row_money">{{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income) }}</div>

        <div class="sub_grid">
          <div class="sub_item">
            <div class="sub_label">{{ $t('team.today') }}</div>
            <div class="sub_val black">{{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income_to) }}</div>
          </div>
          <div class="sub_item">
            <div class="sub_label">{{ $t('team.yesterday') }}</div>
            <div class="sub_val black">{{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income_ye) }}</div>
          </div>
        </div>
      </div>

      <!-- 4个团队统计 -->
      <div class="stat_grid_4">
        <div class="stat_item">
          <div class="stat_label">{{ $t('team.total') }}</div>
          <div class="stat_val blue">{{ report.add_count }}</div>
        </div>
        <div class="stat_item">
          <div class="stat_label">Level 1</div>
          <div class="stat_val blue">{{ report.one }}</div>
        </div>
        <div class="stat_item">
          <div class="stat_label">Level 2</div>
          <div class="stat_val blue">{{ report.two }}</div>
        </div>
        <div class="stat_item">
          <div class="stat_label">Level 3</div>
          <div class="stat_val blue">{{ report.there }}</div>
        </div>
      </div>
    </div>

    <!-- ================= 2. 佣金比例/总数/佣金卡片 ================= -->
    <div class="card_box grid_card_3">
      <div class="grid_item_3">
        <div class="icon_bg purple"><svg aria-hidden="true" class="icon_svg" focusable="false" viewBox="0 0 512 512"><path fill="currentColor" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"/></svg></div>
        <div class="item_title">{{ $t('utils.yjbili') }}</div>
        <div class="item_val text_purple">{{ teams.yjbili }}%</div>
      </div>
      <div class="grid_item_3">
        <div class="icon_bg blue"><svg aria-hidden="true" class="icon_svg" focusable="false" viewBox="0 0 640 512"><path fill="currentColor" d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"/></svg></div>
        <div class="item_title">{{ $t('team.total') }}</div>
        <div class="item_val text_black">{{ teams.count }}</div>
      </div>
      <div class="grid_item_3">
        <div class="icon_bg orange"><svg aria-hidden="true" class="icon_svg" focusable="false" viewBox="0 0 512 512"><path fill="currentColor" d="M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"/></svg></div>
        <div class="item_title">{{ $t('utils.yj') }}</div>
        <div class="item_val text_orange">{{ common.currency_symbol_basic() }}{{ teams.yongjin }}</div>
      </div>
    </div>

    <!-- ================= 3. 级别 Tab 切换 ================= -->
    <div class="level_tabs">
      <div class="tab_item" :class="{ active: actives == 1 }" @click="dianji(1)">Level 1</div>
      <div class="tab_item" :class="{ active: actives == 2 }" @click="dianji(2)">Level 2</div>
      <div class="tab_item" :class="{ active: actives == 3 }" @click="dianji(3)">Level 3</div>
    </div>

    <!-- ================= 4. 用户列表 ================= -->
    <div class="card_box list_card">
      <div class="list_header">
        <span class="icon">👥</span> {{ $t('team.teamList') }} Level {{ actives }}
      </div>
      
      <div class="list_wrap">
        <!-- 关键点：loading 和 finished 配合 -->
        <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
          <div class="list_item" v-for="(item, index) in list" :key="index">
            <div class="item_row">
              <span class="item_time">{{ item.act_time }}</span>
              <span class="vip_mini_tag">{{ item.vip_name }}</span>
            </div>
            <div class="item_row">
              <span class="item_id">ID: {{ item.id }}</span>
              <span class="item_black_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(item.recharge_sum) }}</span>
            </div>
            <div class="item_row">
              <span class="item_username">{{ $t('team.username') }}: {{ item.username }}</span>
              <span class="item_gray_label">{{ $t('team.totalRecharge') }}</span>
            </div>
          </div>
        </van-list>
        <van-empty v-if="empty" :description="$t('utils.noData')" />
      </div>
	  
    </div>

    <!-- 底部安全占位 -->
    <div style="height: 60px;"></div>

    <!-- ================= 分享弹窗 ================= -->
    <van-popup v-model:show="show_share" position="bottom" closeable close-icon-position="top-left">
      <div class="share_wrap">
        <div class="share">
          <div class="invite_friend"><p /></div>
          <div class="share_code">
            <img :src="user_info.share_code">
          </div>
          <div class="invite_code flex_center">
            <p>{{ $t('user.invite_code') }}:</p>
            <p class="code_link" @click="copyText(user_info.invite_code)">
              {{ user_info.invite_code }} <img class="copy_img" src="../img/user/copy.png">
            </p>
          </div>
          <div class="invite_code flex_center">
            <p>{{ $t('team.inviteLink') }}</p>
            <div class="flex_center invite_link">
              <p class="code_link" @click="copyText(user_info.share_link)">{{ user_info.share_link }}</p>
              <img class="copy_img" src="../img/user/copy.png">
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon, List, Empty, Popup } from "vant";
import bsHeader from '../../components/bsHeader.vue';

Vue.use(Icon).use(List).use(Empty).use(Popup);

export default {
  name: "Team",
  data() {
    return {
      user_info: [],
      report: {
        direct_count: 0, indirect_count: 0, income: 0, income_to: 0, income_ye: 0,
        add_count: 0, add_count_to: 0, add_count_ye: 0, one: 0, two: 0, there: 0
      },
      show_share: false,
      actives: 1,
      empty: false,
      loading: false,   // 是否正在加载
      finished: false,  // 是否加载完毕
      list: [],
      teams: [],
      page: 1,
      listRows: 8
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('team');
  },
  mounted() {
    this.start();
  },
  methods: {
    copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast(this.$t('recharge.copySuccess'));
        }).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$toast(this.$t('recharge.copySuccess'));
      } catch (err) {
        this.$toast("Replication failed");
      }
      document.body.removeChild(textArea);
    },
    
    // 切换 Tab
    dianji(e) {
      if (this.actives === e) return;
      
      this.actives = e;
      this.list = [];
      this.page = 1;
      this.finished = false; // 重置完成状态
      
      this.myteam();
      
      // 手动触发加载 (只会请求当前这一页)
      this.loading = true;
      this.onLoad(); 
    },
    
    myteam() {
      Fetch('/user/myTeams', { level: this.actives }).then((r) => {
        this.teams = r.data;
      });
    },
    
    start() {
      this.myteam();
      Fetch('/user/myTeam').then((r) => {
        this.user_info = r.data.user_info;
        this.report = r.data.report;
        this.rate = 100;
      });
      
      // 页面一加载，主动执行一次请求
      this.loading = true;
      this.onLoad();
    },
    
    // 核心：只执行一次加载逻辑
    onLoad() {
      // 防止重复请求
      if (this.loading === false || this.finished) return;

      Fetch('/user/teamList', {
        page: this.page,
        listRows: this.listRows,
        level: this.actives
      }).then(r => {
        // 1. 无论成功与否，先把 Loading 关掉
        this.loading = false; 
        
        // 2. 处理数据
        if (r.data.list.length === 0 && this.list.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
          for (var i = 0; i < r.data.list.length; i++) {
            this.list.push(r.data.list[i]);
          }
        }
        
        // 3. 【最重要一步】拿到数据后，直接结束，不再触发下一次请求！
        this.finished = true; 
        
      }).catch(() => {
        // 如果报错，也结束掉，否则会无限报错
        this.loading = false;
        this.finished = true; 
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* ========== 页面基础样式 ========== */
.basic_wrap {
  min-height: 100vh;
  background-color: #f0f4fa;
  background-image: linear-gradient(#dce5ef 1px, transparent 1px), linear-gradient(90deg, #dce5ef 1px, transparent 1px);
  background-size: 24px 24px;
  padding-bottom: 60px;
}

.page_header {
  padding: 16px 0 12px 16px;
  .header_title {
    font-size: 18px;
    font-weight: 700;
    color: #111;
  }
}

.card_box {
  background: #ffffff;
  border-radius: 18px;
  width: 94%;
  margin: 0 auto 12px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  border: 1px solid rgba(220, 229, 239, 0.6);
}

/* ========== 1. 邀请人信息卡片 ========== */
.user_card {
  .user_info_top {
    display: flex;
    gap: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf2fa;
    
    .avatar_box {
      width: 54px; height: 54px;
      border-radius: 50%; overflow: hidden;
      border: 2px solid #d7e4f8; flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    
    .info_mid {
      flex: 1; display: flex; flex-direction: column; justify-content: center; gap: 6px;
      .user_row {
        display: flex; justify-content: space-between; align-items: center;
        .user_name { font-size: 16px; font-weight: 700; color: #1a2742; }
        .vip_tag {
          display: inline-block; background: #f3f8ff; color: #2e78ff;
          border: 1px solid #cfe0fa; padding: 2px 10px; border-radius: 8px;
          font-size: 11px; font-weight: 700;
        }
        .sub_text { color: #607798; font-size: 11px; }
      }
    }
  }

  .invite_link_row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 0; border-bottom: 1px solid #edf2fa;
    .link_text { 
      flex: 1; color: #607798; font-size: 13px; 
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
    }
  }

  .copy_btn {
    display: flex; align-items: center; gap: 4px;
    height: 30px; padding: 0 12px; border-radius: 8px;
    background: #f3f8ff; border: 1px solid #cfe0fa; color: #607798;
    font-size: 12px; font-weight: 700; cursor: pointer; flex-shrink: 0;
    .copy_icon { width: 14px; height: 14px; }
    &:active { background: #e9f0fe; }
  }

  .revenue_section {
    padding: 14px 0 10px;
    .row_label { color: #7d8ca4; font-size: 12px; margin-bottom: 4px; }
    .row_money { color: #1e7bff; font-size: 24px; font-weight: 800; line-height: 1; margin-bottom: 14px; }
    
    .sub_grid {
      display: grid; grid-template-columns: 1fr 1fr; gap: 10px;
      .sub_item {
        background: #f7faff; border: 1px solid #e5eefb; border-radius: 10px;
        padding: 10px 12px;
        .sub_label { color: #7486a2; font-size: 12px; margin-bottom: 6px; }
        .sub_val { font-size: 16px; font-weight: 700; &.black { color: #1a2742; } }
      }
    }
  }

  .stat_grid_4 {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;
    .stat_item {
      background: #f7faff; border: 1px solid #e5eefb; border-radius: 8px;
      padding: 10px 4px; text-align: center;
      .stat_label { color: #7486a2; font-size: 11px; margin-bottom: 4px; }
      .stat_val { font-size: 16px; font-weight: 700; &.blue { color: #1e7bff; } }
    }
  }
}

/* ========== 2. 三个数据网格 ========== */
.grid_card_3 {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; padding: 16px 12px;
  .grid_item_3 {
    background: #f8faff; border: 1px solid #e5eefb; border-radius: 12px;
    padding: 14px 0; text-align: center;
    
    .icon_bg {
      width: 32px; height: 32px; border-radius: 8px;
      display: inline-flex; align-items: center; justify-content: center;
      margin-bottom: 8px; 
      .icon_svg { width: 16px; height: 16px; color: #fff; }
      &.purple { background: #8b5cf6; }
      &.blue { background: #3b82f6; }
      &.orange { background: #f59e0b; }
    }
    .item_title { color: #7486a2; font-size: 11px; margin-bottom: 4px; }
    .item_val { font-size: 15px; font-weight: 700; 
      &.text_purple { color: #8b5cf6; } &.text_black { color: #111; } &.text_orange { color: #f59e0b; }
    }
  }
}

/* ========== 3. 级别 Tab ========== */
.level_tabs {
  display: flex; gap: 10px; width: 94%; margin: 0 auto 12px;
  .tab_item {
    flex: 1; height: 40px; line-height: 40px; text-align: center;
    background: #ffffff; border-radius: 22px; font-weight: 600; color: #333;
    cursor: pointer; transition: all 0.25s; border: 1px solid #e5eefb;
    &.active { background: #2563eb; color: #fff; border-color: #2563eb; box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3); }
    &:active { transform: scale(0.96); }
  }
}

/* ========== 4. 列表卡片 ========== */
.list_card { padding: 16px 12px; }
.list_header {
  display: flex; align-items: center; gap: 8px; font-size: 15px; font-weight: 700; color: #111;
  margin-bottom: 14px; .icon { font-size: 16px; }
}
.list_wrap {
  .list_item {
    background: #f8faff; border: 1px solid #e5eefb; border-radius: 14px; padding: 14px;
    margin-bottom: 10px;
    
    .item_row {
      display: flex; justify-content: space-between; align-items: center; padding: 2px 0;
      .item_time { font-size: 12px; color: #555; }
      .vip_mini_tag { background: #f3f8ff; color: #2563eb; font-size: 11px; padding: 2px 8px; border-radius: 6px; font-weight: 600; }
      .item_id { font-size: 13px; color: #333; font-weight: 500; }
      .item_black_val { font-size: 13px; color: #111; font-weight: 600; }
      .item_username { font-size: 13px; color: #333; font-weight: 500; }
      .item_gray_label { font-size: 12px; color: #888; }
    }
  }
}

/* ========== 分享弹窗 ========== */
.share_wrap { text-align: center; padding: 20px 0; background: #fff; border-radius: 16px 16px 0 0; }
.share { margin-top: 0; }
.invite_code {
  margin: 10px 20px 20px 20px; justify-content: space-between;
  .code_link { color: #2563eb; font-weight: bold; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; cursor: pointer; display: flex; align-items: center; gap: 6px; }
  .invite_link { max-width: 60%; }
  .copy_img { width: 16px; height: 16px; }
}
.invite_friend { padding: 10px; font-size: 16px; font-weight: bold; }
.share_code { margin-bottom: 20px; img { max-width: 60%; } }
</style>